import * as React from "react";
import { MenuItem, Spinner } from "@chakra-ui/react";
import { IoArchiveOutline } from "react-icons/io5";
import { setErrorsFromResponse, useToast } from "duck";
import {
  OrganizationStatusEnum,
  useUpdateOrganizationMutation
} from "requests";

interface StatusChange {
  id: number;
  status: OrganizationStatusEnum;
  onSuccess(): Promise<any>;
}

const StatusChange: React.FC<StatusChange> = ({ id, status, onSuccess }) => {
  const toast = useToast();
  const [update, { loading }] = useUpdateOrganizationMutation();

  return (
    <MenuItem
      onClick={() =>
        update({
          variables: {
            input: {
              _id: id,
              status:
                status === OrganizationStatusEnum.Active
                  ? OrganizationStatusEnum.Archived
                  : OrganizationStatusEnum.Active
            }
          }
        })
          .then(() => onSuccess())
          .then(() => {
            toast({
              description: "Organization is updated successfully.",
              status: "success"
            });
          })
          .catch(error => {
            setErrorsFromResponse(error);
          })
      }
      icon={
        loading ? <Spinner width="12px" height="12px" /> : <IoArchiveOutline />
      }
    >
      {status === OrganizationStatusEnum.Active ? "Archive" : "Make active"}
    </MenuItem>
  );
};

export default StatusChange;
